<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    :multiple="multiple"
    clearable
    filterable
    @update:modelValue="update"
  >
    <el-option
      v-for="item in items"
      :key="item.id"
      :label="`ID: ${item.id} - ${item.attributes.name}`"
      :value="item.id"
    >
      ID: {{ item.id }} - {{ item.attributes.name }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, watch, ref } from 'vue'

export default defineComponent({
  name: 'CampaignSelect',
  props: {
    modelValue: {
      required: true,
      type: [String, Array]
    },
    items: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const defaultProps = { ...props }
    const update = function (newValue: any) {
      if (props.multiple) {
        context.emit(
          'update:modelValue',
          newValue.map((x: any) => String(x))
        )
      } else {
        context.emit('update:modelValue', String(newValue))
      }
    }

    watch(
      (_: any) => props.items,
      (val: any, oldVal: any) => {
        const newIds = val.map((x: any) => x.id).sort()
        const oldIds = oldVal.map((x: any) => x.id).sort()
        if (JSON.stringify(newIds) !== JSON.stringify(oldIds)) {
          update(defaultProps.modelValue)
        }
      }
    )

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, value }
  }
})
</script>
